import { createStore, applyMiddleware, compose } from 'redux';
import { routerMiddleware, syncHistoryWithStore } from 'react-router-redux';
import { browserHistory } from 'react-router';
import thunkMiddleware from 'redux-thunk';
import createLogger from 'redux-logger';
import rootReducer from './reducers/index';

let loggedUser;

try {
    loggedUser = JSON.parse(sessionStorage.getItem('user'));
}catch(e) {
    loggedUser = null;
}
const defaultState = {
    session : {
        user : loggedUser,
        loggedAt : sessionStorage.getItem('logged_at'),
    }
};

const historyMiddleware = routerMiddleware(browserHistory);
const loggerMiddleware = createLogger();
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

export const store = createStore(rootReducer, defaultState, 
    composeEnhancers(applyMiddleware(historyMiddleware, thunkMiddleware, loggerMiddleware))
);
export const history = syncHistoryWithStore(browserHistory, store);




/** WEBPACK FOOTER **
 ** ./src/store.js
 **/